export const formatPhoneNumber = (inputValue: string) => {
  const phoneNumberOnlyDigits = inputValue?.replace(/\D/g, '')

  const parts = [
    phoneNumberOnlyDigits?.slice(0, 2),
    phoneNumberOnlyDigits?.slice(2, 6),
    phoneNumberOnlyDigits?.slice(6, 10)
  ]

  const formattedPhoneNumber = parts
    ?.filter((part) => part?.length > 0)
    ?.join('-')

  return formattedPhoneNumber
}
